(function () {
  'use strict';

  var readyPromise = null;
  var readyState = { ready: false, synced: false, error: null };
  var requestQueue = Promise.resolve();
  var listeners = [];

  function clone(value) { try { return JSON.parse(JSON.stringify(value)); } catch (_) { return value; } }
  function baseUrl() {
    var root = document.querySelector('[data-app-proxy]');
    return root && root.dataset.appProxy || '/apps/justpress-sets';
  }
  function normalize(record) {
    record = record && typeof record === 'object' ? record : { handle: record };
    var handle = String(record.handle || '').trim().toLowerCase();
    var productGid = String(record.product_gid || record.productGid || (record.productId ? 'gid://shopify/Product/' + String(record.productId).replace(/\D/g, '') : '')).trim();
    var legacyDesignId = String(record.legacy_design_id || record.legacyDesignId || record.design_id || record.designId || '').trim();
    if (legacyDesignId === productGid || legacyDesignId === 'handle:' + handle) legacyDesignId = '';
    var designUnitId = String(record.design_unit_id || record.designUnitId || record.code || '').trim();
    if (!designUnitId && legacyDesignId && !/^gid:\/\/shopify\/Product\//i.test(legacyDesignId) && !/^handle:/i.test(legacyDesignId)) {
      designUnitId = legacyDesignId.replace(/^(?:unit|code):/i, '');
    }
    var designId = String(productGid || designUnitId || legacyDesignId || (handle ? 'handle:' + handle : '')).trim();
    if (!designId) return null;
    var savedAt = record.savedAt || record.saved_at || new Date().toISOString();
    return {
      designId: designId,
      design_id: designId,
      productGid: productGid || null,
      product_gid: productGid || null,
      handle: handle,
      code: String(record.code || '').trim(),
      designUnitId: designUnitId || null,
      design_unit_id: designUnitId || null,
      legacyDesignId: legacyDesignId || null,
      legacy_design_id: legacyDesignId || null,
      title: String(record.title || '').trim(),
      url: String(record.url || '').trim(),
      image: String(record.image || '').trim(),
      savedAt: savedAt,
      saved_at: savedAt,
      source: record.source || 'library'
    };
  }
  function aliases(record) {
    var item = normalize(record);
    if (!item) return [];
    return [item.designId, item.productGid, item.designUnitId && 'unit:' + item.designUnitId, item.code && 'code:' + item.code, item.legacyDesignId, item.handle && 'handle:' + item.handle].filter(Boolean).filter(function (value, index, values) { return values.indexOf(value) === index; });
  }
  function sameIdentity(left, right) {
    var rightAliases = aliases(right);
    return aliases(left).some(function (value) { return rightAliases.indexOf(value) > -1; });
  }
  function normalizeAll(records) {
    var output = [];
    (Array.isArray(records) ? records : []).forEach(function (record) {
      var item = normalize(record);
      if (!item) return;
      var index = output.findIndex(function (existing) { return sameIdentity(existing, item); });
      if (index < 0) output.push(item);
      else output[index] = normalize(Object.assign({}, output[index], item, {
        productGid: item.productGid || output[index].productGid,
        product_gid: item.productGid || output[index].productGid,
        handle: item.handle || output[index].handle,
        code: item.code || output[index].code,
        designUnitId: item.designUnitId || output[index].designUnitId,
        title: item.title || output[index].title,
        url: item.url || output[index].url,
        image: item.image || output[index].image
      }));
    });
    return output;
  }
  function current() { return window.JPState ? normalizeAll(window.JPState.read().saved) : []; }
  function replace(records, reason) {
    var normalized = normalizeAll(records);
    if (window.JPState) window.JPState.replaceSaved(normalized, reason || 'saved-service');
    listeners.slice().forEach(function (listener) {
      try { listener(clone(normalized)); }
      catch (error) { if (window.JPRuntime) window.JPRuntime.reportError(error, 'saved-design-listener'); }
    });
    return normalized;
  }
  async function api(path, options) {
    var headers = Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, options && options.headers || {});
    var response = await fetch(baseUrl() + path, Object.assign({ credentials: 'same-origin' }, options || {}, { headers: headers }));
    var result = await response.json().catch(function () { return {}; });
    if (!response.ok || result.ok === false) {
      var error = new Error(result.error || 'Saved Designs could not be synchronized.');
      error.code = result.code || 'ACCOUNT_DRAFT_SYNC_FAILED';
      error.status = response.status;
      error.requestId = result.request_id || '';
      throw error;
    }
    return result;
  }
  function appendSavedSync(record) {
    if (!window.JPState) return;
    window.JPState.update(function (state) {
      state.syncQueue = Array.isArray(state.syncQueue) ? state.syncQueue : [];
      state.syncQueue.push(record);
      return state;
    }, 'saved-sync-pending');
  }
  function updateSavedSync(operationId, values) {
    if (!window.JPState) return;
    window.JPState.update(function (state) {
      state.syncQueue = Array.isArray(state.syncQueue) ? state.syncQueue : [];
      var index = state.syncQueue.findIndex(function (entry) { return entry && entry.operationId === operationId; });
      if (index >= 0) state.syncQueue[index] = Object.assign({}, state.syncQueue[index], values || {});
      return state;
    }, 'saved-sync-status');
  }
  function operationId(prefix) {
    return prefix + '-' + (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2));
  }
  async function refreshFromServer() {
    if (!(window.JPIdentity && window.JPIdentity.isCustomer())) return current();
    var result = await api('/saved-designs', { method: 'GET' });
    var merged = normalizeAll((result.saved || []).concat(current()));
    if (merged.length !== (result.saved || []).length) {
      result = await api('/saved-designs/merge', { method: 'POST', body: JSON.stringify({ designs: merged }) });
      merged = normalizeAll(result.saved || merged);
    }
    return replace(merged, 'saved-server-refresh');
  }
  async function claimGuestSnapshot(record) {
    if (!(window.JPIdentity && window.JPIdentity.isCustomer())) throw new Error('Customer authentication is required to claim a guest draft.');
    var snapshot = record && record.snapshot || {};
    var request = { guest_id: record.guestId, operation_id: record.operationId, snapshot: snapshot };
    var issued = await api('/guest-drafts/credential', { method: 'POST', body: JSON.stringify(request) });
    var result = await api('/guest-drafts/claim', {
      method: 'POST',
      body: JSON.stringify(Object.assign({}, request, { credential: issued.credential }))
    });
    if (result.saved) replace(result.saved, 'guest-claim-server-merge');
    return result;
  }
  async function retryPendingSaved() {
    if (!(window.JPIdentity && window.JPIdentity.isCustomer() && window.JPState)) return [];
    var pending = (window.JPState.read().syncQueue || []).filter(function (entry) { return entry && entry.type === 'saved' && entry.status === 'pending'; });
    var results = [];
    for (var index = 0; index < pending.length; index += 1) {
      var entry = pending[index];
      try {
        var result = await api('/saved-designs', { method: 'PUT', body: JSON.stringify({ designs: current(), operation_id: entry.operationId }) });
        replace(result.saved || current(), 'saved-retry-success');
        updateSavedSync(entry.operationId, { status: 'synced', syncedAt: Date.now(), lastError: '' });
        results.push({ operationId: entry.operationId, synced: true });
      } catch (error) {
        updateSavedSync(entry.operationId, { status: 'pending', attempts: Number(entry.attempts || 0) + 1, lastAttemptAt: Date.now(), lastError: String(error && error.message || error) });
        results.push({ operationId: entry.operationId, synced: false });
      }
    }
    return results;
  }
  function init() {
    if (readyPromise) return readyPromise;
    readyPromise = Promise.resolve().then(async function () {
      if (!(window.JPIdentity && window.JPIdentity.isCustomer())) {
        readyState = { ready: true, synced: false, reason: 'guest', error: null };
        return current();
      }
      await refreshFromServer();
      await retryPendingSaved();
      readyState = { ready: true, synced: true, error: null };
      return current();
    }).catch(function (error) {
      readyState = { ready: true, synced: false, error: { code: error.code || 'ACCOUNT_DRAFT_SYNC_FAILED', status: error.status || 0, requestId: error.requestId || '', message: String(error && error.message || error) } };
      document.dispatchEvent(new CustomEvent('justpress:saved-sync-error', { detail: { code: error.code || 'ACCOUNT_DRAFT_SYNC_FAILED', status: error.status || 0, requestId: error.requestId || '' } }));
      return current();
    }).finally(function () {
      document.dispatchEvent(new CustomEvent('justpress:saved-ready', { detail: { saved: current(), synced: readyState.synced, error: readyState.error } }));
    });
    return readyPromise;
  }
  function isSaved(record) {
    var item = normalize(record);
    return Boolean(item && current().some(function (entry) { return sameIdentity(entry, item); }));
  }

  /* SAVE-COUNT-1 (contract SAVE_COUNT_PRODUCT@1): after a save succeeds, tell the count service once.
     Unsaving never calls it. The product page reads the public count once per visit. */
  var COUNT_READ_BASE = 'https://justpress-save-count.zhq19981210.workers.dev';
  var COUNT_WRITE_PATH = '/apps/justpress-sets/save-count/v1/saves';
  var COUNT_DEVICE_KEY = 'justpress:saved-count:device:v1';
  var COUNT_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  var counts = {};
  function countProductId(item) {
    var match = /^gid:\/\/shopify\/Product\/(\d+)$/.exec(String(item && item.productGid || ''));
    return match ? match[1] : '';
  }
  function newUuid() {
    var c = window.crypto;
    if (c && typeof c.randomUUID === 'function') return String(c.randomUUID()).toLowerCase();
    if (!(c && c.getRandomValues)) return '';
    var b = c.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return (x + 256).toString(16).slice(1); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }
  function countDeviceId() {
    try {
      var id = String(localStorage.getItem(COUNT_DEVICE_KEY) || '');
      if (COUNT_UUID.test(id)) return id;
      id = newUuid();
      if (!COUNT_UUID.test(id)) return '';
      localStorage.setItem(COUNT_DEVICE_KEY, id);
      return localStorage.getItem(COUNT_DEVICE_KEY) === id ? id : '';
    } catch (_) { return ''; }
  }
  function shortCount(n) {
    return n >= 1000 ? (Math.floor(n / 100) / 10).toFixed(1).replace(/\.0$/, '') + 'k' : String(n);
  }
  function paintCount(productId) {
    var entry = counts[productId];
    if (!entry) return;
    document.querySelectorAll('[data-jp-save-count]').forEach(function (node) {
      if (node.dataset.productId !== productId) return;
      var min = parseInt(node.dataset.min, 10);
      if (!(min >= 0)) min = 10;
      while (node.firstChild) node.removeChild(node.firstChild);
      if (entry.n >= min) {
        var label = document.createElement('span');
        label.textContent = node.dataset.label || 'Saved by';
        var faces = document.createElement('span');
        faces.className = 'jp-product-proof__avatars';
        faces.setAttribute('aria-hidden', 'true');
        ['J', 'P', '+'].forEach(function (letter) { var i = document.createElement('i'); i.textContent = letter; faces.appendChild(i); });
        var number = document.createElement('strong');
        number.textContent = shortCount(entry.n);
        node.append(label, faces, number);
      } else {
        var first = document.createElement('span');
        first.textContent = node.dataset.firstLabel || 'Be one of the first to save it';
        node.appendChild(first);
      }
      node.style.visibility = '';
    });
  }
  function applyCount(productId, body) {
    if (!body || body.ok !== true || String(body.product_id) !== productId) return;
    var n = Number(body.saved_count);
    if (!(n >= 0) || Math.floor(n) !== n) return;
    var since = String(body.tracking_since || '');
    var previous = counts[productId];
    if (previous && previous.since === since && previous.n > n) n = previous.n;
    counts[productId] = { n: n, since: since };
    paintCount(productId);
    document.dispatchEvent(new CustomEvent('justpress:save-count', { detail: { productId: productId, savedCount: n } }));
  }
  function timedFetch(url, options) {
    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function () { controller.abort(); }, 8000) : 0;
    return fetch(url, Object.assign({}, options, controller ? { signal: controller.signal } : {})).finally(function () { window.clearTimeout(timer); });
  }
  function postSaveCount(productId, deviceId, retriesLeft) {
    return timedFetch(COUNT_WRITE_PATH, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ product_id: productId, device_id: deviceId })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (response.ok) { applyCount(productId, body); return; }
        // 400 / 403 / 404 / 405 / 503 are answers, not lost responses: never retried.
        document.dispatchEvent(new CustomEvent('justpress:save-count-error', { detail: { status: response.status, code: body && body.code || '' } }));
      });
    }, function () {
      // No response (network error or timeout): resend the same event once, same device id.
      if (retriesLeft > 0) return postSaveCount(productId, deviceId, retriesLeft - 1);
    });
  }
  function reportSave(item) {
    var productId = countProductId(item);
    if (!productId) return;
    var deviceId = countDeviceId();
    if (!deviceId) return;
    postSaveCount(productId, deviceId, 1).catch(function () {});
  }
  function readCounts() {
    var seen = {};
    document.querySelectorAll('[data-jp-save-count]').forEach(function (node) {
      var productId = String(node.dataset.productId || '');
      if (!/^\d+$/.test(productId) || seen[productId]) return;
      seen[productId] = true;
      timedFetch(COUNT_READ_BASE + '/v1/counts/' + productId, { method: 'GET', credentials: 'omit', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (body) { if (body) applyCount(productId, body); })
        .catch(function () {});
    });
  }
  function toggleSaved(record) {
    var item = normalize(record);
    if (!item || !window.JPState) return false;
    var active = isSaved(item);
    window.JPState.toggleSavedLocal(item);
    var customer = Boolean(window.JPIdentity && window.JPIdentity.isCustomer());
    if (!active && !customer && isSaved(item)) reportSave(item);
    if (customer) {
      var op = operationId('saved');
      appendSavedSync({ operationId: op, type: 'saved', status: 'pending', attempts: 0, createdAt: Date.now(), action: active ? 'remove' : 'save', designId: item.designId });
      requestQueue = requestQueue.then(function () {
        return api('/saved-designs', { method: 'PUT', body: JSON.stringify({ designs: current(), operation_id: op }) });
      }).then(function (result) {
        replace(result.saved || current(), 'saved-server-sync');
        updateSavedSync(op, { status: 'synced', syncedAt: Date.now(), lastError: '' });
        if (!active && isSaved(item)) reportSave(item);
      }).catch(function (error) {
        updateSavedSync(op, { status: 'pending', attempts: 1, lastAttemptAt: Date.now(), lastError: String(error && error.message || error) });
        document.dispatchEvent(new CustomEvent('justpress:saved-sync-error', { detail: { code: error.code || 'ACCOUNT_DRAFT_SYNC_FAILED', status: error.status || 0, requestId: error.requestId || '' } }));
      });
    }
    return !active;
  }
  function subscribe(listener) {
    if (typeof listener !== 'function') return function () {};
    listeners.push(listener);
    return function () { listeners = listeners.filter(function (entry) { return entry !== listener; }); };
  }
  window.JPSavedDesigns = {
    init: init,
    getAll: current,
    toggleSaved: toggleSaved,
    toggle: toggleSaved,
    isSaved: isSaved,
    refreshFromServer: refreshFromServer,
    claimGuestSnapshot: claimGuestSnapshot,
    retryPendingSaved: retryPendingSaved,
    subscribe: subscribe,
    sameIdentity: sameIdentity,
    normalize: normalize,
    syncStatus: function () { return clone(readyState); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', readCounts, { once: true });
  else readCounts();
})();
